import { render, staticRenderFns } from "./PaymentCenterDeposit.vue?vue&type=template&id=858b4c1c&scoped=true"
import script from "./PaymentCenterDeposit.vue?vue&type=script&lang=js"
export * from "./PaymentCenterDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858b4c1c",
  null
  
)

export default component.exports